import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeAction,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { useInvokeAction } from '@leagueplatform/masonry';
import { GDSIconSource } from '@leagueplatform/genesis-core';
import {
  isLinkAction,
  MasonryDeeplinkAction,
} from '@leagueplatform/masonry-renderers';
import { SpendingAccountCard } from '#components/spending-account-card/spending-account-card.component.tsx';

export const NODE_TYPE_SPENDING_ACCOUNT_CARD = 'spendingAccountCard';

type SpendingAccountCardProps = {
  accountName?: string;
  amount: string;
  ctaText: string;
  icon?: { icon?: GDSIconSource | string; description?: string };
  title: string;
  trailingIcon?: { icon?: GDSIconSource | string; description?: string };
};

export type SpendingAccountCardNodeActions = {
  onClick?: MasonryEngineNodeAction;
};

type SpendingAccountCardNode = MasonryEngineNode<
  typeof NODE_TYPE_SPENDING_ACCOUNT_CARD,
  SpendingAccountCardProps,
  SpendingAccountCardNodeActions,
  {}
>;

export type SpendingAccountCardRendererProps =
  MasonryEngineNodeRendererProps<SpendingAccountCardNode>;

export function SpendingAccountCardRenderer({
  amount,
  ctaText,
  icon,
  trailingIcon,
  title,
  onClick,
  accountName,
}: SpendingAccountCardRendererProps) {
  const invokeAction = useInvokeAction();
  const onClickDeeplinkAction = onClick as MasonryDeeplinkAction;

  const isLink = React.useMemo(
    () => isLinkAction(onClickDeeplinkAction),
    [onClickDeeplinkAction],
  );

  const handleOnClick = React.useCallback(
    (event: React.SyntheticEvent) => {
      if (onClick) {
        invokeAction({
          event,
          ...onClick,
        });
      }
    },
    [invokeAction, onClick],
  );

  return (
    <SpendingAccountCard
      accountName={accountName}
      amount={amount}
      ctaText={ctaText}
      icon={icon}
      title={title}
      trailingIcon={trailingIcon}
      onClick={handleOnClick}
      href={onClickDeeplinkAction?.payload.url}
      isLink={isLink}
    />
  );
}
